import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FormComponent from '../../../Reusable_Components/FormComponent';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';

const OpportunityAssignedUserInput = () => {
  const { assignedUserId = '' } = useParams();
  const decodedId = assignedUserId ? atob(assignedUserId) : assignedUserId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'opportunityAssignedUser';


  useEffect(() => {
    if (assignedUserId) {
      setIsEditing(true);
      fetchAssignedUserDetails();
    }
  }, [assignedUserId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchAssignedUserDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.opportunityAssignedUser}${id}/`, { headers });
      setFormData(response.data?.data ?? response.data);
    } catch (error) {
      console.error('Error fetching assigned user details:', error);
    }
  };

  const assignedUserFields = [
    {
      name: 'opportunity', label: 'Opportunity', type: 'async-select',
      endpoint: API_ROUTES.opportunity,
      getOptionLabel: (o) => o.opportunity_name,
    },
    {
      name: 'user', label: 'User', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Opportunity Assigned User' : 'Assign User to Opportunity'}</h1>
      <FormComponent fields={assignedUserFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default OpportunityAssignedUserInput;
